import { Navigate, Outlet } from "react-router-dom";
import { Stack } from '@mui/material';
import SideBar from "./SideBar";
import React, { useEffect } from "react";
import axios from "axios";

const DashboardLayout = () => {
  const currentUserStr = sessionStorage.getItem('currentUser');
  const isAuthenticated = !!currentUserStr;

  useEffect(() => {
    const updateCallingDetails = async () => {
      if (isAuthenticated && currentUserStr) {
        try {
          const currentUser = JSON.parse(currentUserStr);
          
          // Recovery: If callingId is missing, try to register/fetch it again
          if ((!currentUser.callingId || currentUser.callingId === "undefined") && currentUser.userId) {
             console.log("CallingId missing in DashboardLayout, attempting to recover...");
             try {
                 const chatRegistration = await axios.post('https://backend-stgweb.meftii.com/registerPushToken', {
                    userId: currentUser.userId,
                    firstName: currentUser.firstName || 'User',
                    lastName: currentUser.lastName || ''
                 });
                 
                 if (chatRegistration.data && chatRegistration.data._id) {
                     currentUser.callingId = chatRegistration.data._id;
                     if (chatRegistration.data.token) {
                         currentUser.chatToken = chatRegistration.data.token;
                     }
                     sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
                     console.log("Recovered callingId successfully:", currentUser.callingId);
                 }
             } catch (e) {
                 console.error("Failed to recover callingId in DashboardLayout", e);
             }
          }

          // The requirement is: userId : logged in user id not calling_id e.g 588
          // We assume currentUser.userId holds the numeric/db ID and currentUser.callingId holds the calling ID
          const userId = currentUser.userId || currentUser.id;
          const callingId = currentUser.callingId;
          const email = currentUser.email;

          if (userId && callingId && email) {
            console.log("Sending updatecallingdetails with:", { userId, callingId });
            await axios.post('https://backend-stgweb.meftii.com/updatecallingdetails', {
              userId: userId,
              callingId: callingId,
              token: "",
              device_mode: 1,
              deviceId: ""
            }, {
              headers: {
                email: email
              }
            });
            console.log("Calling details updated successfully via DashboardLayout.");
          } else {
            console.warn("Skipping updatecallingdetails: Missing required fields.", { userId, callingId: !!callingId, email: !!email });
          }
        } catch (error) {
          console.error("Failed to update calling details:", error);
        }
      }
    };

    updateCallingDetails();
  }, [isAuthenticated, currentUserStr]);

  if(!isAuthenticated){
    return <Navigate to='/auth/login'/>;
  }

  return (
    <Stack direction='row' sx={{ height: '100vh' }}> 
      <SideBar/>
      <Outlet />
    </Stack>
  );
};

export default DashboardLayout;